import styles from './styles.module.scss';
import Icon from 'components/icon';
import { useMenu } from 'context/MenuContext';
import { useRef, useState } from 'react';
import useOnClickOutside from 'models/utils/useOnClickOutside';
import Tooltip from 'components/tooltip';
import Item from './item';

function Dropdown() : JSX.Element {
  const { customConfig } = useMenu();
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [isVisible, changeVisibility] = useState(false);

  useOnClickOutside(dropdownRef, onClick);

  const dropdown = customConfig.dropdown;

  function onClick() : void {
    changeVisibility(!isVisible);
  }

  return (
    <div id={styles['biobar-dropdown-container']}>
      <Tooltip text={dropdown.tooltip}>
        <Icon
          iconName={dropdown.iconName}
          onClick={onClick} />
      </Tooltip>
      { isVisible &&
        <div
          ref={dropdownRef}
          id={styles['biobar-dropdown']}
          className={customConfig.inlineManualUrl ? '' : styles['biobar-dropdown-right']}>
          {dropdown.items.map((x, i) => <Item {...x} key={i} /> )}
        </div>
      }
    </div>
  );
}

export default Dropdown;